import fetch, { doGet, doPost } from '../../tools/axios'

const updateNeedInfo = (id, status, cb, edcode) => {
  const _url = `/needs/process`
  const bundle = {
    need_donate_id: id,
    status,
    edcode
  }
  return doPost(_url, bundle, cb)
}

const postNeedInfo = (bundle, cb) => {
  const _url = `/needs/process`
  const { need_donate_id: id } = bundle
  if (!id) {
    console.warn('NeedAPI方法 請求參數中需要帶上 need_donate_id 一值')
  }
  return doPost(_url, bundle, cb)
}

export default {
  submitNewNeed (data, cb) {
    return fetch('post', `/needs`, {data}, cb)
  },
  getNeedList ({page = 1, onPool = 1, userRoleType = '', isTraceUser = '', sort = '', status = '', directPurchase = '',
    category = '', bureauId = '', noRequestList = 1, maxNeedId = '', shipway = '', needSectionId = '', needSectionType = '', cb = null}) {
    const query = (userRoleType && `&user_role_type=${userRoleType}`) +
      (isTraceUser && `&is_trace_user=${isTraceUser}`) +
      (sort && `&sort=${sort}`) +
      (status && `&status=${status}`) +
      (directPurchase && `&direct_purchase=${directPurchase}`) +
      (category && `&need_items_category_id=${category}`) +
      (bureauId && `&bureau_id=${bureauId}`) +
      (maxNeedId && `&max_need_id=${maxNeedId}`) +
      (shipway && `&shipway=${shipway}`) +
      (needSectionId && `&need_section_id=${needSectionId}`) +
      (needSectionType && `&need_section_type=${needSectionType}`)
    return fetch('get', `/needs${noRequestList ? '/home' : ''}?page=${page}&on_pool=${onPool}${query}`, {}, cb)
  },
  getNeedInfo (id, cb, returnDonates = 0) {
    return fetch('get', `/needs/${id}?return_donates=${returnDonates}`, {}, cb)
  },
  getNeedDonateInfo (id, cb) {
    return fetch('get', `/needDonate/${id}`, {}, cb)
  },
  /* eslint-disable */
  /* 取消需求 */
  confirmShip (bundle, cb) {
    const _url = `/needs/process`
    return doPost(_url, bundle, cb)
  },
  /* 取消需求 */
  cancelNeedDonate (need_donate_id, cb) {
    return updateNeedInfo(need_donate_id, 'cancel', cb)
  },
  /* 忽略需求 */
  ignoreNeedDonate (need_donate_id, cb) {
    return updateNeedInfo(need_donate_id, 'pass', cb)
  },
  // 贈送需求
  needsDonate (data, cb) {
    return fetch('post', '/needs/donate', {data}, cb)
  },
  /* 贈送需求，多個品項 */
  needsDonateItems (data) {
    return doPost('/needs/donateItems', data)
  },
  /* 需求贈送 */
  sendNeed (bundle, cb) {
    bundle.status = 'remitting'
    return postNeedInfo(bundle, cb)
  },
  /* 確認轉帳信息 */
  transferNeed (bundle, cb) {
    bundle.status = 'remitted'
    return postNeedInfo(bundle, cb)
  },
  /* 確認收貨信息 */
  receiveMoneyNeed (need_donate_id, cb, edcode) {
    return updateNeedInfo(need_donate_id, 'received_money', cb, edcode)
  },
  /* 確認寄出信息 */
  sentNeed (need_donate_id, cb) {
    return updateNeedInfo(need_donate_id, 'sent', cb)
  },
  /* 完成 */
  finishNeed (need_donate_id, cb) {
    return updateNeedInfo(need_donate_id, 'finished', cb)
  },
  /* 感谢 */
  thanksNeed (bundle, cb) {
    bundle.status = 'thanks'
    return postNeedInfo(bundle, cb)
  },
  // 編輯需求
  editNeed (data, id, cb) {
    return fetch('put', `/needs/${id}`, {data}, cb)
  },
  getNeedDonateList (needId, page, perPage) {
    return doGet(`/needDonate?need_id=${needId}&page=${page}&perPage=${perPage}`)
  },
  getAvailableNeedSections () {
    return doGet('/need_sections/available')
  },
  getNeedSections (page, perPage = 20, type = '') {
    return doGet(`/need_sections?page=${page}&perPage=${perPage}${type ? `&type=${type}` : ''}`)
  },
  getNeedSectionDetail (needSectionId) {
    return doGet(`/need_sections/${needSectionId}`)
  },
  getNeedSectionItemCount (type = '', name = '') {
    return doGet(`/need_sections/need_count?type=${type}&name=${name}`)
  }
}
